
const form = document.getElementById('contact-form');

document.addEventListener("DOMContentLoaded", () => {
  const inputs = document.querySelectorAll("input");
  inputs.forEach((input) => {
    input.addEventListener("change", (event) => {
      setTimeout(() => {
        const x = event.target.value;
        event.target.value = '';
        event.target.value = x;
      }, 500);
    });
  });
});

form.addEventListener('submit', async (event) => {
  event.preventDefault();


  const formData = new FormData(form);
  let data = Object.fromEntries(formData.entries());




  if (data.address) return; //Anti bot check, we do not need address


  data.info = {
    url: window.location.href,
    time: new Date().toLocaleString(),
    timespent: TimeMe.getTimeOnCurrentPageInSeconds(),
    userid: userid,
    ip: await ipPromise
  }

  try {
    const response = await firebase('sendEmail', data);
    if (response.ok) {
      window.tsTrack && window.tsTrack('contact_form_submit', { form: 'contact' });
      showSuccessModal();
      form.reset();
    } else {
      showErrorModal();
    }
  } catch (error) {
    showErrorModal();
  }


});


function getResponseDate() {
  let date = new Date();
  let workingDaysToAdd = 2;

  while (workingDaysToAdd > 0) {
    // Incrementa di 1 giorno
    date.setDate(date.getDate() + 1);
    const dayOfWeek = date.getDay(); // 0 = Domenica, 6 = Sabato

    // Se il giorno non è sabato o domenica, decrementa il contatore
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      workingDaysToAdd--;
    }
  }
  return date;
}

// Funzione per mostrare il modal con il messaggio
function showSuccessModal() {
  const responseDate = getResponseDate();
  const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
  const formattedDate = responseDate.toLocaleDateString('it-IT', options);

  const modalBody = document.querySelector('#successModal .modal-body');
  modalBody.innerHTML = `<p>Thank you! Your message has been sent! &#128522;</p><p>We usually reply much sooner, ` + getWeekendMessage() + `, you can expect a response by <strong>${formattedDate}</strong> at the latest.</p><p>Just a heads-up—we work in the CET timezone.</p><p>Talk soon! &#128640;</p>`;

  // Inizializza e mostra il modal Bootstrap
  (new bootstrap.Modal(document.getElementById('successModal'))).show();
}

function getWeekendMessage(date = new Date()) {
  const day = date.getDay(); // 0 = Domenica, 6 = Sabato
  let msg = "but just to be safe";
  if (day === 6 || day === 0) {
    msg = "but since it's " + (day === 6 ? 'Saturday' : 'Sunday') + " and we don't work on weekends"
  }
  return msg;
}

function showErrorModal() {
  (new bootstrap.Modal(document.getElementById('errorModal'))).show();
}